import { render, staticRenderFns } from "./SgSettingsPhoneEdit.vue?vue&type=template&id=68818cb0&"
import script from "./SgSettingsPhoneEdit.vue?vue&type=script&lang=js&"
export * from "./SgSettingsPhoneEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports